import { CommonModule } from '@angular/common';
import { Component, Inject, Input, Signal } from '@angular/core';
import { TranslationModule } from '../../../i18n/translation-module';
import { ActivityInterface } from '@vendasta/crm';
import { RouterLink } from '@angular/router';
import {
  ActivityAssociationDisplayInfo,
  ActivityAssociationDisplayInfoGroup,
  ActivityAssociationService,
} from './activity-association.service';
import { GalaxyPopoverModule, PopoverPositions } from '@vendasta/galaxy/popover';
import { MatIconModule } from '@angular/material/icon';
import { CrmMultiLocationDependencies, CrmMultilocationInjectionToken } from '../../../tokens-and-interfaces';
import { toSignal } from '@angular/core/rxjs-interop';
import { of } from 'rxjs';

@Component({
  selector: 'crm-association-popover',
  templateUrl: './association-popover.component.html',
  styleUrls: ['./association-popover.component.scss'],
  imports: [CommonModule, TranslationModule, RouterLink, GalaxyPopoverModule, MatIconModule],
})
export class CrmActivityAssociationPopoverComponent {
  @Input() set activity(activity: ActivityInterface) {
    this.associationService.activity = activity;
  }
  get activity() {
    return this.associationService.activity;
  }

  @Input() hideDivider = false;

  popupOpen = {};
  PopoverPositions = PopoverPositions;

  companies: Signal<ActivityAssociationDisplayInfo[]> = this.associationService.companies;
  contacts: Signal<ActivityAssociationDisplayInfo[]> = this.associationService.contacts;
  customObjectGroups: Signal<ActivityAssociationDisplayInfoGroup[]> = this.associationService.customObjectGroups;
  opportunities: Signal<ActivityAssociationDisplayInfo[]> = this.associationService.opportunities;
  teamMembers: Signal<ActivityAssociationDisplayInfo[]> = this.associationService.teamMembers;
  routePrefix: Signal<string> = this.associationService.routePrefix;
  numberOfAssociations: Signal<number | null> = this.associationService.numberOfAssociations;
  isMultiLocation = toSignal(this.multiLocationConfig.isMultiLocation$ ?? of(false));

  constructor(
    @Inject(CrmMultilocationInjectionToken) private readonly multiLocationConfig: CrmMultiLocationDependencies,
    private readonly associationService: ActivityAssociationService,
  ) {}

  openPopover(activity: ActivityInterface): void {
    this.popupOpen[activity.crmObjectId] = true;
  }
}
